document.documentElement.classList.remove('no-js');

(() => {
  const q = (selector, root = document) => root.querySelector(selector);
  const qa = (selector, root = document) => [...root.querySelectorAll(selector)];

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    } catch (e) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }[char]));

  const mobileButton = q('.js-mobile-menu');
  const mobileNav = q('#MobileNav');
  if (mobileButton && mobileNav) {
    mobileButton.addEventListener('click', () => {
      const open = mobileButton.getAttribute('aria-expanded') === 'true';
      mobileButton.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
    });
  }

  qa('[data-media-target]').forEach((button) => {
    button.addEventListener('click', () => {
      qa('[data-media-target]').forEach((item) => item.classList.remove('active'));
      qa('[data-media-panel]').forEach((panel) => panel.classList.add('is-hidden'));
      button.classList.add('active');
      const panel = document.getElementById(button.dataset.mediaTarget);
      if (panel) panel.classList.remove('is-hidden');
    });
  });

  const drawer = q('#CartDrawer');
  const backdrop = q('.js-cart-backdrop');

  const openDrawer = () => {
    if (!drawer || !backdrop) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    if (!drawer || !backdrop) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.hidden = true;
    document.body.style.overflow = '';
  };

  qa('.js-cart-open').forEach((button) => button.addEventListener('click', openDrawer));
  qa('.js-cart-close').forEach((button) => button.addEventListener('click', closeDrawer));
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  const syncUpsells = (cart) => {
    if (!drawer) return;
    const block = q('.js-cart-upsells', drawer);
    if (!block) return;

    const productIds = new Set(cart.items.map((item) => String(item.product_id)));
    let visible = 0;

    qa('.js-cart-upsell', block).forEach((item) => {
      const inCart = productIds.has(String(item.dataset.upsellProductId));
      item.hidden = inCart;
      if (!inCart) visible += 1;
    });

    block.hidden = visible === 0;
  };

  const renderCart = async () => {
    if (!drawer) return;
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();

    qa('.js-cart-count').forEach((el) => { el.textContent = cart.item_count; });

    const body = q('.js-cart-drawer-body', drawer);
    const subtotal = q('.js-cart-subtotal', drawer);
    const checkout = q('.js-cart-checkout', drawer);

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (checkout) checkout.classList.toggle('is-hidden', cart.item_count === 0);
    syncUpsells(cart);

    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = `
        <div class="empty-cart">
          <h3>Your cart is empty.</h3>
          <p>Start with a tool that earns its place.</p>
          <!-- [ASSUMED — verify] /collections/all is the intended browse destination. -->
          <a class="btn secondary" href="/collections/all">Shop Products</a>
        </div>`;
      bindCartChanges();
      return;
    }

    body.innerHTML = cart.items.map((item, index) => {
      // [ASSUMED — verify] Launch product handle is upright-safety-mandoline-slicer.
      const preorder = item.handle === 'upright-safety-mandoline-slicer'
        ? '<p class="cart-note">Batch 1 ships in 3–4 weeks.</p>'
        : '';
      const title = escapeHtml(item.product_title);
      const url = escapeHtml(item.url);
      const key = escapeHtml(item.key);
      const image = item.image
        ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">`
        : '';
      return `
        <div class="cart-item">
          <div class="cart-thumb">${image}</div>
          <div>
            <a class="cart-title" href="${url}">${title}</a>
            ${preorder}
            <div class="cart-item__actions">
              <div class="qty">
                <button type="button" data-cart-change="${key}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-change="${key}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
              </div>
              <a class="cart-remove" href="/cart/change?line=${index + 1}&quantity=0" data-cart-change="${key}" data-quantity="0" aria-label="Remove ${title}">Remove</a>
            </div>
          </div>
          <strong>${formatMoney(item.final_line_price)}</strong>
        </div>`;
    }).join('');

    bindCartChanges();
  };

  const changeLine = async (key, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (response.ok) await renderCart();
  };

  const bindCartChanges = () => {
    qa('[data-cart-change]', drawer || document).forEach((control) => {
      control.onclick = (event) => {
        event.preventDefault();
        changeLine(control.dataset.cartChange, Number(control.dataset.quantity));
      };
    });
  };
  bindCartChanges();

  qa('.js-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = q('[type="submit"]', form);
      if (submit) submit.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) {
          form.submit();
          return;
        }
        await renderCart();
        openDrawer();
      } catch (error) {
        form.submit();
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  });
})();
